let cached: Promise<Blob> | null = null

export function getEmptyMp3Blob(): Promise<Blob> {
  if (!cached) {
    cached = fetch('/empty.mp3').then(async (res) => {
      if (!res.ok) {
        cached = null
        throw new Error(`Failed to fetch empty.mp3: ${res.status}`)
      }
      return res.blob()
    })
  }
  return cached
}
